<template>
  <div class='account'>
    <div class="onehome">
      <van-icon @click='back' class="return" color="#fff" name="arrow-left" />
      <h3 class="title">物业查询</h3>
      <div class="imgbox">
        <van-icon name="chat-o" size='.6rem' color='#fff' @click='toModule("/personal/News")' />
        <van-icon name="scan" style="margin-left:6px" color="#fff" size='.6rem' @click='toScan' />
      </div>
    </div>
    <div class="bigbox">
      <!-- <div @click="payf">缴费</div> -->
      <router-link v-if="isshow" style="color:red;" tag="a" :to="`/propertyDetiles/${commonService.houserz}`">申请开通线上查询物业费</router-link>
      <!-- <p class="jinp">近三个月</p> -->
      <div class="box" :style='note' @click='detalis(month)'>
        <p><span class="month">{{month>=10?month:"0"+month}}</span><br>{{year}}</p>
        <!-- <p><span class="moey">￥{{qrow}}</span><br><span class="jine">{{parseInt(zrow)==0?'已缴':'待缴'}}金额</span></p> -->
        <p class="zoomj"><span class="moey">合计:{{qrow}}</span><br><span class="jine">{{zrowtext==1?parseInt(zrow)==0?'已缴':'待缴:'+zrow:'无数据'}}</span></p>
        <p>详情</p>
      </div>
      <div class="box" :style="note2"  @click='detalis(month-1)'>
        <p><span class="month">{{month-1>=10?month-1:"0"+(month-1)}}</span><br>{{year}}</p>
        <!-- <p><span class="month">{{12}}</span><br>{{2019}}</p> -->
        <p class="zoomj"><span class="moey">合计:{{qrowone}}</span><br><span class="jine">{{zrowonetext==1?parseInt(zrowone)==0?'已缴':'待缴:'+zrowone:'无数据'}}</span></p>
        <p>详情</p>
      </div>
      <div class="box" :style="note3" @click='detalis(month-2)'>
        <p><span class="month">{{month-2>=10?month-2:"0"+(month-2)}}</span><br>{{year}}</p>
        <!-- <p><span class="month">{{12}}</span><br>{{2019}}</p> -->
        <p class="zoomj"><span class="moey">合计:{{qrowtwo}}</span><br><span class="jine">{{zrowtwotext==1?parseInt(zrowtwo)==0?'已缴':'待缴:'+zrowtwo:'无数据'}}</span></p>
        <p>详情</p>
      </div>
      
    </div>
    <div>
      <van-tabbar v-model="active">
        <van-tabbar-item :to="`/index?parkId=${this.currentParkId}`"><div class="divicon"><van-icon size='22px' name="wap-home" />首页</div></van-tabbar-item>
        <van-tabbar-item to="/propertys"><div class="divicon"><van-icon size='22px' name="like-o" />服务</div></van-tabbar-item>
       <van-tabbar-item :to="`${this.currentParkId == 1003||this.currentParkId == 1000||this.currentParkId == 1006?'/parkCompleteSet/foodCourt':'/humanResource/jobList'}`"><div class="divicon"><van-icon size='22px' name="location-o" />附近</div></van-tabbar-item>
        <van-tabbar-item to="/parkCompleteSet/ExclusiveActivities"><div class="divicon"><van-icon size='22px' name="point-gift-o" />活动</div></van-tabbar-item>
        <van-tabbar-item to="/personal"><div class="divicon"><van-icon size='22px' name="contact" />我的</div></van-tabbar-item>
      </van-tabbar>
    </div>
    
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import { Toast } from 'vant';
import commonService from '@/static/commonService';

export default {
  data(){
    return {
      active:4,
      isshow:true,
      unitCode:"",
      unitCodes:"",
      qiniuConfig: {},
      commonService: {},
      zrow:0,
      zrowone:0,
      zrowtwo:0,
      zrowtext:0,
      zrowonetext:0,
      zrowtwotext:0,
      qrow:0,
      details:'',
      user:'',
      qrowone:0,
      qrowtwo:0,
      Newslist:[],
      list:[],
      year: new Date().getFullYear(),
      month : new Date().getMonth()+1,
      lengg:0,
      oneun:'',
      total_proceeds:'',
      total_profits:'',
      scanConfig: {   // 扫码配置参数
        appId: '',
        timestamp: '',
        nonceStr: '',
        signature: '',
      },
      note: {
        backgroundImage: "url(" + require("../../static/image/bg1.jpg") + ")",
      },
      note2: {
        backgroundImage: "url(" + require("../../static/image/bg2.jpg") + ")",
      },
      note3: {
        backgroundImage: "url(" + require("../../static/image/bg3.jpg") + ")",
      },
    };
  },

  methods: {
    getUploadToken() {
      this.$http.post(`${this.URL_PREFIX}/app/get/qiniu/bucket/token`, {}, {
        headers: { token: this.token },
      }).then((response) => {
        const res = response.data;
        if (res.resCode === '10000') {
          this.qiniuConfig = res.resData;
        }
      });
    },
    getrentrecently() {
      this.$http.post(`${this.URL_PREFIX}/app/get/user/info/rentrecently`, {
        parkId: this.currentParkId,
        unitCode: this.unitCodes,
      }, {
        headers: { token: this.token },
      }).then((response) => {
        const res = response.data;
        if(res.resCode === '10000') {
          this.details = res.resData;
          }
      });
    },
    payf(){
     this.$http.post(`${this.URL_PREFIX}/app/added/rent/order`, {
        userId:this.user.userId,
        userPhone:this.user.userMobile,
        userName:this.user.userNick,
        parkId: this.currentParkId,
        area: "0.01",
        // arrears: this.zqs,
        arrears: "0.01",
        details:this.details,
      },{
        headers: { token: this.token },
      }).then((respon) => {
        const res = respon.data;
        if(res.resCode === '10000') {
          this.orderId = res.resData.orderId;
          window.location.href = `${this.URL_PREFIX_PAGE}/smark/pay/wechat?orderId=${this.orderId}&paymentId=${1}&wxTradeType=${2}&invoiceMarker=${1}`;
        }
      });
    },
    getlist() {
      // 解析年月
      let year = new Date().getFullYear();
      let month = new Date().getMonth()+1;
      // let unitCode = this.unitCode;

      this.$http.post(`${this.URL_PREFIX}/app/get/user/info/rent`, {
        year, month,parkId: this.currentParkId,
      },{
        headers: { token: this.token },
      }).then((respon) => {
        const res = respon.data;
        if(res.resCode === '10000') {
          this.list = res.resData;
          let zcont = 0;
          let qcont = 0;
          var arr = []
          for (let i in res.resData) {
              arr.push(res.resData[i]); //属性
          }

          for(var s=0;s<arr.length;s++){
              for(var g = 0;g<arr[s].length;g++){
                zcont += parseInt(arr[s][g].Arrears*100000000000000)/100000000000000;
                qcont += parseInt(arr[s][g].AccountReceivable*100000000000000)/100000000000000;
                this.zrowtext = 1;
              }
          }
          this.zrow = zcont.toFixed(2);
          this.qrow = qcont.toFixed(2);
        }
      });
    },
    getlistone() {
      // 解析年月
      let year = new Date().getFullYear();
      let month = new Date().getMonth();
      // let unitCode = this.unitCode;

      this.$http.post(`${this.URL_PREFIX}/app/get/user/info/rent`, {
        year, month,parkId: this.currentParkId,
      },{
        headers: { token: this.token },
      }).then((respon) => {
        const res = respon.data;
        if(res.resCode === '10000') {
          this.list = res.resData;
          let zcont = 0;
          let qcont = 0;
          var arr = []
          for (let i in res.resData) {
              arr.push(res.resData[i]); //属性
          }

          for(var s=0;s<arr.length;s++){
              for(var g = 0;g<arr[s].length;g++){
                zcont += parseInt(arr[s][g].Arrears*100000000000000)/100000000000000;
                qcont += parseInt(arr[s][g].AccountReceivable*100000000000000)/100000000000000;
                this.zrowonetext = 1;
              }
          }
          this.zrowone = zcont.toFixed(2);
          this.qrowone = qcont.toFixed(2);
        }
      });
    },
    getlisttwo() {
      // 解析年月
      let year = new Date().getFullYear();
      let month = new Date().getMonth()-1;
      // let unitCode = this.unitCode;

      this.$http.post(`${this.URL_PREFIX}/app/get/user/info/rent`, {
        year, month,parkId: this.currentParkId,
      },{
        headers: { token: this.token },
      }).then((respon) => {
        const res = respon.data;
        if(res.resCode === '10000') {
          this.list = res.resData;
          let zcont = 0;
          let qcont = 0;
          var arr = []
          for (let i in res.resData) {
              arr.push(res.resData[i]); //属性
          }

          for(var s=0;s<arr.length;s++){
              for(var g = 0;g<arr[s].length;g++){
                  // console.log(arr[s][g].Arrears);
                zcont += parseInt(arr[s][g].Arrears*100000000000000)/100000000000000;
                qcont += parseInt(arr[s][g].AccountReceivable*100000000000000)/100000000000000;
                this.zrowtwotext = 1;
              }
          }
          this.zrowtwo = zcont.toFixed(2);
          this.qrowtwo = qcont.toFixed(2);
        }
      });
    },
    getbianm(){
      this.$http.post(`${this.URL_PREFIX}/app/get/user/info/detail`, {},{
        headers: { token: this.token },
      }).then((respon) => {
        const res = respon.data;
        if(res.resCode === '10000') {
          this.user = res.resData;
          if(res.resData.unitCode){
            this.unitCodes = res.resData.unitCode;
            this.isshow = false;
            this.options = [];
            const leng = res.resData.unitCode.split(",").length;
            if(leng == 1){
              this.lengg = 1;
              this.oneun = res.resData.unitCode.split(",")[0];
            }
            for(var i = 0; i < leng; i++){
                this.options.push({
                  value: res.resData.unitCode.split(",")[i],
                  label: res.resData.unitCode.split(",")[i]
                });
            }
          } 
        }
      });
    },
    detalis(id) {
      if(this.lengg == 1){
        this.$router.push({ path: `/BianDetalis/${id}/${this.oneun}` });
      }else{
        this.$router.push({ path: `/PayDetalis/${id}` });
      }
    },
    toModule(path) {
      this.$router.push({ path: path });
    },
    back(){
        this.$router.go(-1);//返回上一层
    },
    toScan() {
      if (!this.token) {
        this.$root.eventHub.$emit('login', this.$route.fullPath);
      } else {
        this.getJsSdkConfigParams();
      }
    },
    // 获取微信扫码配置
    getJsSdkConfigParams() {
      this.$http.post(`${this.URL_PREFIX}/app/get/wx/jssdk/config/info`, {
        url: location.href.split('#')[0]
      }, {
        headers: { token: this.token }
      }).then((response) => {
        const res = response.data;
        if (res.resCode === '10000') {
          this.scanConfig.appId = res.resData.appId;
          this.scanConfig.timestamp = res.resData.timestamp;
          this.scanConfig.nonceStr = res.resData.nonceStr;
          this.scanConfig.signature = res.resData.signature;
          this.config();
        } else {
          Toast.fail({ duration: 1500, message: res.resDesc });
        }
      });
    },
    // 扫码
    config() {
      wx.config({
        debug: false,
        appId: this.scanConfig.appId,
        timestamp: this.scanConfig.timestamp,
        nonceStr: this.scanConfig.nonceStr,
        signature: this.scanConfig.signature,
        jsApiList: ['checkJsApi', 'scanQRCode']
      });


      // 配置出错
      wx.error((res) => {
        Toast.fail({ duration: 1500, message: `${res.errMsg}` });
      });

      // 配置成功之后的回调
      wx.ready(() => {
        wx.checkJsApi({
          jsApiList : ['scanQRCode'],
          success : (res) => {
          }
        });
        wx.scanQRCode({
          /**
           * 此处为0才能使用PC官网的扫一扫登陆功能
           * 因为微信的登陆二维码做了特殊处理，必须直接由微信扫码跳转过去才行
           * 例如把微信登陆二维码识别为文本url后再点击也是不行的，必须由微信直接扫码跳转（微信会识别来源方式）
           * 所以如果要兼容官网微信登陆功能，这里就无法由我们自行处理二维码内容
           */
          needResult : 0,
          scanType : ["qrCode"],
        });
      });
    },
  },
  computed: {
    ...mapGetters(['token', 'currentParkId']),
  },
  created() {
    this.getUploadToken();
    this.getbianm();
    this.getlist();
    this.getlistone();
    this.getlisttwo();
    // this.getrentrecently();
    this.commonService = commonService[process.env.commonServiceConfKey][this.currentParkId];
  },
};
</script>

<style lang="scss" scoped>
@import '~@scss';
.account{
  .onehome{
    background: #205eff;
    width: 100%;
    height: 1.2rem;
    display: flex;
    justify-content:space-between;
    align-items: center;
    .return{
      padding-left: .18rem;
    }
    .title{
      text-align: center;
      color: #fff;
      padding-left: .88rem;
    }
    .imgbox{
      height: 100%;
      display: flex;
      align-items: center;
      padding-right: .18rem;
    }
  }
  .bigbox{
    padding: .4rem;
    .jinp{
      padding: .4rem;
    }
    .box{
      height: 2.36rem;
      border-radius: .2rem;
      margin: .4rem 0;
      background-repeat: no-repeat;
      background-size: 100%;
      display: flex;
      justify-content: space-around;
      align-items: center;
      color: #fff;
      .zoomj{
        text-align: center;
      }
      p{
        .month{
          font-size: .68rem;
          margin-left: .16rem;
        }
        .moey{
          font-size: .38rem;
        }
        .jine{
          // font-size: .32rem;
          color: #eef712;
        }
      }
    }
  }
  .divicon{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    i{
      padding-bottom: .1rem;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/pages/personal/Pay.vue